import useGroupMembers from '../../../hooks/useGroupMembers'
import { Button, ButtonLoader } from '@wellesley/ui'
import { Send } from 'lucide-react'
import { FC } from 'react'
import CommonDialog from 'components/modals/CommonDialog'
import UserSelect from 'components/UserSelect'
import { User } from '@wellesley/openapi'
import { FormProvider } from 'react-hook-form'
import useInviteForm from './hooks/useInviteForm'

type CmpProps = {
  isOpen: boolean
  onClose: () => void
  groupId: string
}

const InviteModal: FC<CmpProps> = ({ isOpen, onClose, groupId }) => {
  const { members } = useGroupMembers({
    groupId,
  })

  const { form, onSubmit, isLoading, handleClose } = useInviteForm({
    groupId,
    onClose,
  })

  const existingMembers = members?.map((member) => member.memberId) || []

  const hasSelectedUsers = form.watch('users').length > 0

  return (
    <CommonDialog
      open={isOpen}
      onCloseModal={handleClose}
      title="Invite members"
      onOpenAutoFocus={(e) => e.preventDefault()}
      childrenClassName="overflow-hidden"
    >
      <p className="mb-xxs text-sm font-medium text-gray-700">Add members</p>
      <FormProvider {...form}>
        <form onSubmit={(args) => void form.handleSubmit(onSubmit)(args)}>
          <UserSelect
            form={form}
            users={form.watch('users') as User[]}
            searchText={form.watch('search') ?? ''}
            setSearchText={(text) => form.setValue('search', text)}
            onSelect={(users) => form.setValue('users', users)}
            placeholder="Invite your followers or enter a username or email to invite friends"
            filter={existingMembers}
          />
          <div className="relative mt-m flex items-center justify-end gap-xxs pt-m before:absolute before:-left-m before:-right-m before:top-0 before:h-px  before:bg-gray-200 before:content-['']">
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <ButtonLoader
              type="submit"
              disabled={!hasSelectedUsers}
              variant="primary"
              isLoading={isLoading}
            >
              <Send className="mr-xxs" /> Send invites
            </ButtonLoader>
          </div>
        </form>
      </FormProvider>
    </CommonDialog>
  )
}

export default InviteModal
